type CruisePostPurchasePricing = {
  cruiselineAdditionalCharges: number;
  cruiselineFee: number;
  cruiseLeFee: number;
  refareDepositFeeAlreadyPaid?: number;
  refareNewFare?: number;
  refareNewTaxAndSurcharges?: number;
};

export function calculateCruisePostPurchaseTotals({
  cruiselineAdditionalCharges,
  cruiselineFee,
  cruiseLeFee,
  refareDepositFeeAlreadyPaid = 0,
  refareNewFare = 0,
  refareNewTaxAndSurcharges = 0,
}: CruisePostPurchasePricing) {
  const toCents = (amount: number) => Math.round(Number(amount) * 100);
  const vendorTotalInCents =
    toCents(cruiselineFee) +
    toCents(cruiselineAdditionalCharges) +
    toCents(refareNewFare) +
    toCents(refareNewTaxAndSurcharges) -
    toCents(refareDepositFeeAlreadyPaid);

  return {
    total: (vendorTotalInCents + toCents(cruiseLeFee)) / 100,
    vendorTotal: vendorTotalInCents / 100,
  };
}
